import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { StudentBookingErrorResponse } from 'src/api/types';

import { getUserExists } from '../../api/user';

export const useGetUserExists = (
    config?: UseMutationOptions<boolean, AxiosError<StudentBookingErrorResponse>, string>
) => {
    const mutation = useMutation<boolean, AxiosError<StudentBookingErrorResponse>, string>({
        ...config,
        mutationFn: (email: string) => getUserExists(email),
    });

    return {
        ...mutation,
    };
};
